//#region src/crypto.js
var randomBytes = () => {
	throw new Error("Not available on this platform");
};
//#endregion
export { randomBytes };

//# sourceMappingURL=crypto.mjs.map